"use strict";
exports.__esModule = true;
exports.TwoFactorChannels = exports.TokenizationProvider = exports.RiskWorkflows = exports.RiskActions = exports.MfaStates = exports.RiskClientAppName = exports.Experience = exports.ErrorTypes = exports.ErrorCodes = void 0;
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["AccountBlocked"] = "account_blocked";
    ErrorCodes["InvalidCode"] = "invalid_code";
    ErrorCodes["PaymentCardNotVerified"] = "payment_card_not_verified";
    ErrorCodes["ReenterPaymentCard"] = "reenter_payment_card";
    ErrorCodes["TooManyAttempts"] = "too_many_attempts";
    ErrorCodes["VerificationRequired"] = "verification_required";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));
var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["DoorDashMFAError"] = "DOORDASH_MFA_ERROR";
})(ErrorTypes = exports.ErrorTypes || (exports.ErrorTypes = {}));
var Experience;
(function (Experience) {
    Experience["DoorDash"] = "doordash";
    Experience["Caviar"] = "caviar";
    Experience["WhiteLabeled"] = "white_labeled";
    Experience["Storefront"] = "storefront";
})(Experience = exports.Experience || (exports.Experience = {}));
var RiskClientAppName;
(function (RiskClientAppName) {
    RiskClientAppName["Dasher"] = "dasher";
    RiskClientAppName["Default"] = "doordash_consumer";
    RiskClientAppName["MerchantPortal"] = "merchant_portal";
    RiskClientAppName["MerchantMobile"] = "merchant_mobile";
})(RiskClientAppName = exports.RiskClientAppName || (exports.RiskClientAppName = {}));
var MfaStates;
(function (MfaStates) {
    MfaStates["AutoSendFailed"] = "auto_send_failed";
    MfaStates["Blocked"] = "blocked";
    MfaStates["Loading"] = "loading";
    MfaStates["Verification"] = "verification";
})(MfaStates = exports.MfaStates || (exports.MfaStates = {}));
var RiskActions;
(function (RiskActions) {
    RiskActions["PhoneEmailVerify"] = "phone_email_verify";
    RiskActions["PaymentCardNotVerified"] = "payment_card_not_verified";
    RiskActions["ReenterPaymentCard"] = "reenter_payment_card";
    RiskActions["RegisterCallback"] = "register_callback";
    RiskActions["Reset"] = "reset";
    RiskActions["VerificationRequired"] = "verification_required";
    RiskActions["RequiresThreeDSecure"] = "request_three_d_secure";
    RiskActions["RequiresThreeDSecureM2"] = "request_three_d_secure_m2";
})(RiskActions = exports.RiskActions || (exports.RiskActions = {}));
var RiskWorkflows;
(function (RiskWorkflows) {
    RiskWorkflows["ChangePassword"] = "change_password";
    RiskWorkflows["ConsumerReferral"] = "consumer_referral";
    RiskWorkflows["CxSignup"] = "cx_signup";
    RiskWorkflows["DasherLogin"] = "dasher_login";
    RiskWorkflows["DasherLoginUpdatePhone"] = "dasher_login_update_phone";
    RiskWorkflows["DasherSignup"] = "dasher_signup";
    RiskWorkflows["DeleteAccount"] = "delete_account";
    RiskWorkflows["DxForgotPassword"] = "dx_forgot_password";
    RiskWorkflows["DxLogin"] = "dx_login";
    RiskWorkflows["DxSignup"] = "dx_signup";
    RiskWorkflows["EditPhoneOnCheckout"] = "edit_phone_on_checkout";
    RiskWorkflows["EditProfile"] = "edit_profile";
    RiskWorkflows["ForgotPassword"] = "forgot_password";
    RiskWorkflows["Login"] = "login";
    RiskWorkflows["MxBankAccountUpdate"] = "mx_bank_account_update";
    RiskWorkflows["MxCreateEmployeeProfile"] = "mx_create_employee_profile";
    RiskWorkflows["MxForgotPassword"] = "mx_forgot_password";
    RiskWorkflows["MxLogin"] = "mx_login";
    RiskWorkflows["MxSignup"] = "mx_signup";
    RiskWorkflows["MxUpdateEmployeeProfile"] = "mx_update_employee_profile";
    RiskWorkflows["PlaceOrder"] = "place_order";
    RiskWorkflows["SelfHelp"] = "self_help";
    RiskWorkflows["Signup"] = "signup";
    RiskWorkflows["SSMOLogin"] = "ssmo_login";
})(RiskWorkflows = exports.RiskWorkflows || (exports.RiskWorkflows = {}));
var TokenizationProvider;
(function (TokenizationProvider) {
    TokenizationProvider["Stripe"] = "stripe";
    TokenizationProvider["VGS"] = "vgs";
})(TokenizationProvider = exports.TokenizationProvider || (exports.TokenizationProvider = {}));
var TwoFactorChannels;
(function (TwoFactorChannels) {
    TwoFactorChannels["Email"] = "email";
    TwoFactorChannels["SMS"] = "sms";
})(TwoFactorChannels = exports.TwoFactorChannels || (exports.TwoFactorChannels = {}));
